<template>
	<div>
		<pui-modal-dialog-form
			:overflow="false"
			:titleText="this.$t('terminal.action.disableTitle')"
			:modelName="modelName"
			v-model="modalData"
			:dialogName="dialogNameDisable"
			:showDialogProp="showDialogDisable"
			:onOk="onOkDisable"
			:widthDialog="800"
			componentHeaderName="terminalformheader"
		>
			<template slot="message">
				<v-layout wrap>
					<v-flex sm8>
						<pui-date-field
							:label="$t('terminal.action.disableLabel')"
							v-model="modalData.fecbaja"
							required
							toplabel
							:min="fechahoy"
							attach="fecbaja"
						></pui-date-field>
					</v-flex>
				</v-layout>
				<v-layout wrap v-if="!isMobile">
					<v-flex xs12 style="height: 60px"></v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
		<pui-modal-dialog
			v-if="modals.enable.show"
			:cancelText="$t('form.cancel')"
			:disableOk="modals.enable.disableOk"
			:okText="$t('form.accept')"
			:titleText="modals.enable.titleText"
			:dialogName="`confirm-${this.modelName}`"
			ref="confirm"
			:widthDialog="700"
		>
			<template slot="message">
				<v-form action>
					<pui-form-header showHeader>
						<terminalformheader :modelPk="parentModelPk"></terminalformheader>
					</pui-form-header>
					<v-layout wrap class="pui-form-layout">
						<v-flex xs12>
							<v-layout>
								<v-flex xs12 align-self-center>
									<span>{{ $t('terminal.validate.enable') }}</span>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-form>
			</template>
		</pui-modal-dialog>
	</div>
</template>

<script>
/* eslint-disable */

export default {
	name: 'terminalmodals',
	data() {
		return {
			modals: {
				enable: {
					disableOk: false,
					show: false,
					titleText: '',
					parentModelPk: null
				}
			},
			modalData: {},
			fechahoy: this.$dateTimeUtils.getLocalDateNow(),
			dialogNameDisable: 'disable',
			showDialogDisable: true
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	mounted() {
		this.subscribeToModalDialogEvent();
	},
	methods: {
		subscribeToModalDialogEvent() {
			this.$puiEvents.$on(`pui-modalDialogForm-${this.dialogNameDisable}-${this.modelName}-show`, (data) => {
				this.showDialogDisable = true;
			});
			// Modal Confirm
			this.$puiEvents.$on(`pui-modalDialog-confirm-${this.modelName}-ok`, () => {
				this.setShowConfirm(false);
				this.$puiEvents.$emit(`pui-action-runAction-` + this.modelName);
			});
			this.$puiEvents.$on(`pui-modalDialog-confirm-${this.modelName}-cancel`, () => {
				this.setShowConfirm(false);
				this.$puiEvents.$off(`pui-action-runAction-` + this.modelName);
				this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
			});
			this.$puiEvents.$on(`pui-modalDialog-confirm-${this.modelName}-show`, (data) => {
				this.parentModelPk = {
					idterminal: data.idterminal
				};
				this.modals.enable.titleText = this.$t('terminal.action.enableTitle');
				this.setShowConfirm(true);
			});
		},
		setShowConfirm(action) {
			this.modals.enable.show = action;
		},
		onOkDisable(modalData) {
			var idterminal = modalData.headerPk.idterminal;
			let urlController = this.$store.getters.getModelByName(this.modelName).url.disable + '?idterminal=' + idterminal;
			var title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t(this.$t('terminal.disableterminal'));
			var params = { date: modalData.fecbaja };

			this.$puiRequests.patchRequest(
				urlController,
				params,
				(response) => {
					this.showDialogDisable = false;
					this.$puiEvents.$emit(`onPui-action-running-showFormLoading-${this.modelName}`);
					this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
					var message = this.$puiI18n.t('puiaction.notifySuccess');
					this.$puiNotify.success(message, title);
				},
				(e) => {
					this.showDialogDisable = false;
					var message = this.$puiI18n.t('puiaction.notifyError');
					if (e.response && e.response.data) {
						message = e.response.data.message;
					}
					this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
					this.$puiNotify.error(message, title);
				}
			);
		}
	},
	destroyed() {
		this.$puiEvents.$off(`pui-modalDialog-confirm-${this.modelName}-ok`);
		this.$puiEvents.$off(`pui-modalDialog-confirm-${this.modelName}-cancel`);
		this.$puiEvents.$off(`pui-modalDialog-confirm-${this.modelName}-show`);
	}
};
</script>
<style lang="postcss" scoped></style>

<i18n>
{
	"en": {
		"terminal.action.disableTitle": "Deactivate",
		"terminal.action.disableLabel": "Deactivate Date",
		"terminal.validate.disable": "The terminal will be deactivated. Do you want to continue?",
		"terminal.validate.enable": "The deactivated terminal will be activated. Do you want to continue?",
		"terminal.action.enableTitle": "Enable"
	},
	"es": {
		"terminal.action.disableTitle": "Desactivar",
		"terminal.action.disableLabel": "Fecha baja",
		"terminal.validate.disable": "Se desactivará la terminal. ¿Desea continuar?",
		"terminal.validate.enable": "Se activará la terminal. ¿Desea continuar?",
		"terminal.action.enableTitle": "Activar"
	},
	"ca": {
		"terminal.action.disableTitle": "Desactivar",
		"terminal.action.disableLabel": "Data de baixa",
		"terminal.validate.disable": "Es desactivarà la terminal. Desitja continuar?",
		"terminal.validate.enable": "S'activarà la terminal. Desitja continuar?",
		"terminal.action.enableTitle": "Activar"
	}
}
</i18n>
